import { createSlice } from "@reduxjs/toolkit";
import { fetchStockOverview } from "./thunk";

interface DistrictState {
  StockOverviewList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: DistrictState = {
  StockOverviewList: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const inventorySlice = createSlice({
  name: "Inventory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStockOverview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStockOverview.fulfilled, (state, action) => {
        state.loading = false;
        state.StockOverviewList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchStockOverview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch StockOverviewList";
      });
  },
});

export default inventorySlice.reducer;
